import React, { useMemo } from 'react';

// 상단 핵심 프로모션 배너 (오늘의 특가 등)
export const CoupangAdTop = ({ adData }) => {
    if (!adData) return null;

    return (
        <div className="coupang-ad-top">
            <a
                href={adData.url}
                target="_blank"
                rel="noopener noreferrer sponsored"
                className="coupang-ad-top-link"
            >
                <div className="coupang-ad-top-content">
                    <span className="coupang-badge">COUPANG</span>
                    <span className="coupang-ad-top-title">{adData.title}</span>
                    <span className="coupang-ad-top-cta">{adData.cta || '바로가기 →'}</span>
                </div>
            </a>
        </div>
    );
};

// 하단 3열 광고 그리드 - rotationKey가 변경될 때마다 자연스럽게 로테이션
export const CoupangAdBottom = ({ products, partnerId, count = 3, rotationKey = 0 }) => {
    // rotationKey가 변경되면 1칸씩 밀려서 자연스럽게 순환
    const displayProducts = useMemo(() => {
        if (!products || products.length === 0) return [];

        // rotationKey를 기반으로 시작 인덱스 계산 (1칸씩 이동)
        const startIndex = rotationKey % products.length;

        // 순환하면서 count개 선택
        const result = [];
        for (let i = 0; i < count; i++) {
            const index = (startIndex + i) % products.length;
            result.push(products[index]);
        }
        return result;
    }, [products, count, rotationKey]);

    if (!products || products.length === 0 || !partnerId) {
        return null;
    }

    return (
        <div className="coupang-ad-container coupang-ad-bottom">
            <h3 className="coupang-ad-title">🔮 행운을 부르는 추천 아이템</h3>
            <div className="coupang-ad-grid">
                {displayProducts.map((product, index) => (
                    <a
                        key={`bottom-${rotationKey}-${index}-${product.url}`}
                        href={product.url}
                        target="_blank"
                        rel="noopener noreferrer sponsored"
                        className="coupang-ad-item"
                    >
                        <img src={product.imageUrl} alt={product.name} className="coupang-ad-image" />
                        <div className="coupang-ad-info">
                            <p className="coupang-ad-name">{product.name}</p>
                            {product.price && <p className="coupang-ad-price">{product.price.toLocaleString()}원</p>}
                        </div>
                    </a>
                ))}
            </div>
            <p className="coupang-ad-disclaimer">이 포스팅은 쿠팡 파트너스 활동의 일환으로, 일정액의 수수료를 제공받습니다.</p>
        </div>
    );
};

// 사이드바 세로형 광고 - 우측에 다이나믹 배너 포함
export const CoupangAdSidebar = ({ products, position = 'left', count = 3, showSearchWidget = false, dynamicBannerUrl = null }) => {
    // useMemo로 컴포넌트 마운트 시 한 번만 순서 결정
    const displayProducts = useMemo(() => {
        if (!products || products.length === 0) return [];
        return products.slice(0, count);
    }, [products, count]);

    if (!products || products.length === 0) {
        return null;
    }

    return (
        <aside className={`coupang-sidebar coupang-sidebar-${position}`}>
            {/* 우측 사이드바 최상단에 다이나믹 배너 표시 */}
            {position === 'right' && dynamicBannerUrl && (
                <div className="coupang-sidebar-item coupang-dynamic-banner">
                    <iframe
                        src={dynamicBannerUrl}
                        width="200"
                        height="200"
                        frameBorder="0"
                        scrolling="no"
                        referrerPolicy="unsafe-url"
                        title="쿠팡 다이나믹 배너"
                    />
                </div>
            )}
            {displayProducts.map((product, index) => (
                <a
                    key={`sidebar-${position}-${index}-${product.url}`}
                    href={product.url}
                    target="_blank"
                    rel="noopener noreferrer sponsored"
                    className="coupang-sidebar-item"
                >
                    <img src={product.imageUrl} alt={product.name} className="coupang-sidebar-image" />
                    <div className="coupang-sidebar-info">
                        <p className="coupang-sidebar-name">{product.name}</p>
                        {product.price && <p className="coupang-sidebar-price">{product.price.toLocaleString()}원</p>}
                    </div>
                </a>
            ))}
            {/* 우측 사이드바에만 검색 위젯 표시 - 작은 버전 사용 */}
            {showSearchWidget && position === 'right' && (
                <div className="coupang-search-widget">
                    <iframe
                        src="https://coupa.ng/ckWu6y"
                        width="100%"
                        height="36"
                        frameBorder="0"
                        scrolling="no"
                        referrerPolicy="unsafe-url"
                        title="쿠팡 검색"
                    />
                </div>
            )}
        </aside>
    );
};

// 다이나믹 캐러셀 광고 위젯 (iframe 버전 - 독립 사용)
export const CoupangCarouselIframe = ({ src, width = "100%", height = "140" }) => {
    return (
        <div className="coupang-carousel-container">
            <iframe
                src={src}
                width={width}
                height={height}
                frameBorder="0"
                scrolling="no"
                referrerPolicy="unsafe-url"
                title="쿠팡 다이나믹 배너"
            />
        </div>
    );
};

// 기존 CoupangAd 컴포넌트 (호환성 유지)
const CoupangAd = ({ products, partnerId, count = 3 }) => {
    return <CoupangAdBottom products={products} partnerId={partnerId} count={count} />;
};

export default CoupangAd;
